import { getNestedFormArray, getNestedFormsByTarget, } from './apply-nested-forms';
export function applyFormOverrides(form, overrides, recursive = true) {
    var _a;
    const nestedFormsByTarget = getNestedFormsByTarget(form);
    const fields = ((_a = form.fields) !== null && _a !== void 0 ? _a : []).map((field) => {
        var _a;
        if (!field.target) {
            return field;
        }
        const override = overrides[field.target];
        if (!override) {
            return field;
        }
        if (field.nestedFormId && recursive) {
            const nestedForm = nestedFormsByTarget === null || nestedFormsByTarget === void 0 ? void 0 : nestedFormsByTarget[field.target];
            if (nestedForm) {
                nestedFormsByTarget[field.target] = applyFormOverrides(nestedForm, override, false);
            }
            return field;
        }
        let validation = field.validation;
        let options = {};
        if (Array.isArray(override.countries)) {
            validation = Object.assign(Object.assign({}, validation), { string: Object.assign(Object.assign({}, validation === null || validation === void 0 ? void 0 : validation.string), { enum: override.countries }) });
            options = override.countries
                ? {
                    options: (_a = override.countries) === null || _a === void 0 ? void 0 : _a.map((country) => ({ value: country })),
                }
                : {};
        }
        return Object.assign(Object.assign(Object.assign({}, field), pick(override, 'hidden')), { view: Object.assign(Object.assign(Object.assign(Object.assign({}, field.view), pick(override, 'label')), pick(override, 'autocomplete')), options), validation: Object.assign(Object.assign({}, validation), pick(override, 'required')) });
    });
    const nestedForms = nestedFormsByTarget
        ? getNestedFormArray(nestedFormsByTarget)
        : undefined;
    return Object.assign(Object.assign(Object.assign({}, form), { fields }), (nestedForms ? { nestedForms } : {}));
}
function pick(override, key) {
    return override.hasOwnProperty(key) ? { [key]: override[key] } : {};
}
//# sourceMappingURL=form-overrides.js.map